/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocflowStandardDialogRequest } from './docflowStandardDialogRequest';
import { DocflowBlackListDialogRequest } from './docflowBlackListDialogRequest';
import { DocflowFatfDialogRequest } from './docflowFatfDialogRequest';


export interface DocflowDialogRequest { 
    standardDialog?: DocflowStandardDialogRequest;
    fatfDialog?: DocflowFatfDialogRequest;
    blackListDialog?: DocflowBlackListDialogRequest;
}

